export const DEFAULT_ACTION = 'screen/WelcomeScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/WelcomeScreen/UPDATE_INPUT';

export const GET_USER_PRIVILEGES = 'screen/WelcomeScreen/GET_USER_PRIVILEGES';
export const GET_USER_PRIVILEGES_LOADING = 'screen/WelcomeScreen/GET_USER_PRIVILEGES_LOADING';
export const GET_USER_PRIVILEGES_SUCCESS = 'screen/WelcomeScreen/GET_USER_PRIVILEGES_SUCCESS';
export const GET_USER_PRIVILEGES_FAIL = 'screen/WelcomeScreen/GET_USER_PRIVILEGES_FAIL';